import * as React from 'react';
import * as SC from "./style"
import { useParams } from "react-router-dom";
import { translate } from 'src/utils/translate';


const Footer: React.FC<any> = (props): JSX.Element => {

  const { language }:any = useParams()
  const onDocumetation = (href: string) => {  
    window.open(href, '_blank');
  }

  return (
    <>
    <SC.StyledFooter>
    <div className='footerSection'>
        <div className='footer'>
            <div className="leftSection">
              <div className='footerLink copyright'>{translate(language,'© 2016-2023, Wikibank Platform, All rights reserved.')}</div>
            </div>
            <div className='footerPolicys'>
                <div onClick={() => onDocumetation("https://wikibank.fr/terms-of-use")} className='footerLink footerText'><a href="#">{translate(language,'Terms of use')}</a></div>
                <div onClick={() => onDocumetation("https://wikibank.fr/legal-notice")} className='footerLink footerText'><a href="#">{translate(language,'Legal notice')}</a></div>
                <div onClick={() => onDocumetation("https://wikibank.fr/gdpr")} className='footerLink footerText'><a href="#">{translate(language,'GDPR')}</a></div>
                <div onClick={() => onDocumetation("https://wikibank.fr/privacy-policy")} className='footerLink footerText'><a href="#">{translate(language,'Privacy policy')}</a></div>
            </div>
        </div>
    </div>
    </SC.StyledFooter>
    </>
  )
}
export default Footer


// WEBPACK FOOTER //
// ./src/pages/common/Footer/Footer.tsx